import { render, staticRenderFns } from "./testPlanStatus.vue?vue&type=template&id=4678574c"
import script from "./testPlanStatus.vue?vue&type=script&lang=js"
export * from "./testPlanStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports